module.exports = __webpack_public_path__ + "static/media/spot2.1f151943.webp";